const env = process.env.NODE_ENV || "development";

const apiEnvironment = {
  development: {
        api: "https://hanoiip-api.cgis.asia/",
        media_url: "https://hanoiip-api.cgis.asia/",
        domainAdminSide: "http://localhost:3000",
        domainUserSide: "http://localhost:3001",
        domainName: "",
        workSpace: "hanoiip",
        wmsBaseLink: "https://geo.cgis.asia/geoserver/hanoiip/wms/",
  },
  production: {
      api: "https://hanoiip-api.cgis.asia/",
      media_url: "https://hanoiip-api.cgis.asia/",
      domainAdminSide: "https://admin.hanoiip.cgis.asia",
      domainUserSide: "https://hanoiip.cgis.asia",
      domainName: "hanoiip.cgis.asia",
      workSpace: "hanoiip",
      wmsBaseLink: "https://geo.cgis.asia/geoserver/hanoiip/wms/",
  },
};

module.exports = apiEnvironment[env];
